export class IntersectionObserverWrapper {
  observer: IntersectionObserver;

  constructor(callback: IntersectionObserverCallback, options?: IntersectionObserverInit) {
    this.observer = new IntersectionObserver(callback, options);
  }

  observe(target: Element) {
    this.observer.observe(target);
  }

  unobserve(target: Element) {
    this.observer.unobserve(target);
  }

  disconnect() {
    this.observer.disconnect();
  }
}
